export default __webpack_public_path__ + "static/media/07-large.c9e6a7ea.jpg";